import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

/**
 * Bloque "¿Te sirvió?" que se monta al final de cada página `/help/*`.
 * El CTA es un botón brutalist que lleva al formulario de contacto.
 */
export function HelpContactBlock() {
  const { t } = useTranslation()
  return (
    <section
      className="my-10 rounded-2xl border-2 border-foreground/15 bg-background-alt p-5 sm:flex sm:items-center sm:justify-between sm:gap-6 sm:p-6"
      role="note"
    >
      <div className="mb-4 sm:mb-0">
        <p className="font-display text-base font-bold sm:text-lg">
          {t('help.common.wasItHelpfulHeading')}
        </p>
        <p className="mt-1 text-sm text-muted-foreground sm:text-base">
          {t('help.common.contactCta')}
        </p>
      </div>
      <Link
        to="/contact"
        className="brutal-sm brutal-press flex w-full items-center justify-center rounded-md bg-yellow px-4 py-2.5 font-brutal text-[11px] font-bold uppercase tracking-widest text-foreground sm:inline-flex sm:w-auto sm:whitespace-nowrap sm:px-5"
      >
        {t('help.common.contactButton')}
      </Link>
    </section>
  )
}
